import { SystemStyleObject } from '@chakra-ui/react';

export interface MountSxParams {
  pagination?: SystemStyleObject;
  paginationBullet?: SystemStyleObject;
  paginationBulletActive?: SystemStyleObject;
  button?: SystemStyleObject;
  buttonNext?: SystemStyleObject;
  buttonBefore?: SystemStyleObject;
  buttonContent?: SystemStyleObject;
}

export function mountSx({
  pagination,
  paginationBullet,
  paginationBulletActive,
  button,
  buttonContent,
  buttonNext,
  buttonBefore,
}: MountSxParams = {}) {
  const swiperButton = {
    color: 'text.primary',
    bg: 'rgba(10, 10, 10, 0.7)',
    borderWidth: '1px',
    borderColor: 'line.strong',
    borderRadius: '2px',
    height: '40px',
    width: '40px',
    position: 'absolute',
    top: 'calc(50% - 20px)',
    backdropFilter: 'blur(8px)',
    transition: 'border-color 0.2s ease, color 0.2s ease',
    ...button,

    _hover: {
      borderColor: 'accent.500',
      color: 'accent.500',
    },

    '&::after': {
      fontSize: '14px',
      fontWeight: 400,
      buttonContent,
    },
  };

  return {
    '.swiper-pagination': {
      padding: '12px 0',
      ...pagination,

      '&-bullet': {
        background: 'var(--chakra-colors-text-faint)',
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        opacity: 0.6,
        ...paginationBullet,

        '&-active': {
          background: 'var(--chakra-colors-accent-500)',
          opacity: 1,
          ...paginationBulletActive,
        },
      },
    },

    '.swiper-button': {
      '&-next': { ...swiperButton, ...buttonNext },
      '&-prev': { ...swiperButton, ...buttonBefore },
    },
  };
}
